<template>
    <div class="input-group select2-input-container">
        <select ref="select2" class="form-control"></select>
        <span class="input-group-btn">
            <button v-if="allowEdit && editFormBaseEndPoint !== undefined"  class="btn blue action-edit" style="margin:0" type="button" @click="editItem">
                <i class="fa fa-edit"></i>
            </button>
            <button v-if="allowAdd && addFormBaseEndPoint !== undefined" class="btn yellow action-add" style="margin:0" type="button" @click="addItem">
                <i class="fa fa-plus"></i>
            </button>
      <button v-if="allowQuickAdd && type === 'part' && addFormBaseEndPoint !== undefined" class="btn blue action-quick-add" style="margin:0" type="button" @click="quickAddItem" title="Création rapide">
        <i class="fa fa-bolt"></i>
      </button>
        </span>
    </div>
</template>

<script>
const { openRapidPartModal } = require('../js/rapidPartModal');

module.exports = {
    name: "select-two-items",
    props: {
      endpoint: {
        type: String,
        required: true
      },
      dropdownParent: {
        type: String,
        default: "body"
      },
      value: {
        type: Object,
      },
      initialValue: {
        type: String,
        required: false
      },
      initialDisplay: {
        type: String,
        required: false
      },
      type: {
        type: String,
        default: "all"
      },
      partNumberFirst: {
        type: Boolean,
        default: false
      },
      addFormBaseEndPoint: {
        type: String,
        required: false
      },
      addFormTitle: {
        type: String,
        default: "Ajout d'un item"
      },
      addFormSelector: {
        type: String,
        required: false
      },
      addTextInputSelector: {
        type: String,
        required: false
      },
      editFormBaseEndPoint: {
        type: String,
        required: false
      },
      editFormTitle: {
        type: String,
        default: "Modifier un item"
      },
      editFormSelector: {
        type: String,
        required: false
      },
      editTextInputSelector: {
        type: String,
        required: false
      },
      allowEdit: {
        type: Boolean,
        default: true
      },
      allowAdd: {
        type: Boolean,
        default: true
      },
      allowQuickAdd: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        items: [],
        loading: true,
        openFocus: false,
        selectedItem: this.value,
      }
    },
    watch: {
      value: function(val){
        let text = this.getSelectionText(val);
        this.selectedItem = this.value;
        $(this.$refs["select2"]).html("<option value='"+val.id+"' selected>"+text+"</option>")
      },
      openFocus: function(val){
        if(val == true){
          $(this.$refs["select2"]).select2("open");
          val = false;
        }
      }
    },
    mounted(){
      this.init();
    },
    methods:{
      getSelectionText: function(item) {
        if (item && item.type === 'part') {
          if (this.partNumberFirst) {
            const number = String(item.label || item.part_number || '').trim() || '*vide*';
            const name = item.name || item.part_name || '';
            return number + ' - ' + name;
          }
          console.log('getSelectionText for part:', item);
          if (
              typeof item.text !== 'string' ||
              !item.text.includes('Q:[')
          ) {
              if (item.label && item.supplier_name) {
                  return item.label + ' - ' + item.supplier_name;
              }
          }

          return item.text;
        }
        return item && item.label !== undefined ? item.label : ((item && item.text) || '');
      },
      // getSelectionLabel: function(item) {
      //   if (item && item.type === 'part') {
      //     console.log('getSelectionLabel for part:', item);
      //     // return item.text || item.label || '';
      //     return item.label || '' +  ' - ' + item.supplier_name || '';
      //   }
      //   return item && item.label !== undefined ? item.label : ((item && item.text) || '');
      // },
      applyItemResult: function(result) {
        const text = this.getSelectionText(result);
        $(this.$refs["select2"]).html(`<option value="${result.id}" selected>${text}</option>`);
        $(this.$refs["select2"]).val(result.id);
        this.selectedItem = result;
        this.$emit("selected", result);
        this.$emit('input', result);
      },
      open()
      {
        $(this.$refs["select2"]).select2("open");
      },
      init: function(){
        var that = this;
        console.log(this.initialValue);
        if(this.initialValue !== undefined){
          $(this.$refs["select2"]).html("<option value='"+this.initialValue+"' selected>"+this.initialDisplay+"</option>")
        }

        $(this.$refs["select2"]).select2({
          language: "fr",
          ajax: {
            url: that.endpoint,
            dataType: 'json',
            data: function (params) {
              let ids;
              if (!that.value.itemId || that.value.itemId == '') { that.value.itemId = that.value.id;}
              if (that.value.itemId) {
                ids = that.value.itemId.toString().split("-");
                if (ids.length > 1){
                  ids = ids[1];
                } else { 
                  ids = ids[0];
                }
              }
              return {
                search: params.term,
                type: that.type,
                page: params.page || 1,
                selectedId: ids
              }
            },
            processResults: function (data) {
              data.results.forEach(function(result) {
                result.itemId = result.id;
                result.id = result.type+"-"+result.id;
              });
              return data;
            }
          },
          placeholder: "",
          allowClear: true,
          dropdownParent: $(that.dropdownParent),
          searchInputPlaceholder: "Rechercher...",
          templateResult: that.renderMethod
          }).on("select2:select", function(data){
            var dat = data.params.data;
            that.selectedItem = dat;
            that.$emit("selected", dat);
            that.$emit('input', dat);
          }).on("select2:clear", function(data){
            that.selectedItem = null
            that.$emit("clear");
            that.$emit('input', {id: null, item_id: null, text: "", type: null});
          });

      },
      renderMethod: function(state){
        if (!state.id) {
          return "Chargement des résultats...";
        }

        var $state = $(`
            <div>
              <div style="line-height: 14px">${state.text != '' ? state.text : "<em>Sans nom</em>"}</div>
            </div>
          `);
        if(state.type == "service"){
          $state.find(".type").html('<b>Service</b>');
        }
        if(state.type == "part"){
          $state =  $(`<table title="${state.name}" style="max-width:265px;table-layout:fixed;"><colgroup><col><col><col><col><col><col><col><col><col><col></colgroup><tr>
            <td colspan=4 class="part-number">${state.label || state.part_number || '*vide*'}</td>
            <td colspan=6 class="small bold part-supplier">${state.supplier_name}</td>
            </tr><tr>
            <td colspan=5 class="part-name">${state.name}</td>
            <td colspan=2 class="small bold part-qty">RT:${state.part_return}</td>
            <td colspan=3 class="small bold part-qty">QT:${state.part_inventory}</td>
            </tr></table>
          `);
          $state.find(".type").html('<b>Pièce</b>');
        }
        if(state.type == "quote_item"){
          $state = $(`
            <div>
              <div style="line-height: 14px">${state.text != '' ? state.text : "<em>Sans nom</em>"}</div>
            </div>
          `);
          $state.find(".type").html('<b>Item de soumission</b>');
        }
        return $state;
      },
      addItem: function(){
        let that = this;
        var message_text = "<h1>"+L("PROCESSING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
        App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });
        let from = "select2";
        if (that.$parent !== null && that.$parent.$parent !== null &&
            that.$parent.$parent.$options.name == "supplier-invoice-item-list")
            {
              from = "select2supplier";
            }
        $.post(this.addFormBaseEndPoint, { from: from }, (msg) => {
          App.unblockUI();  
          var popup = bootbox.dialog({ 
            message: msg,
            title: that.addFormTitle,
            className: "modal-item",
            size: "medium",
            onEscape: function(){
              that.$emit("onCancel")
              return true
            },
            buttons: {
              save: {
                label: L("SAVE"),
                className: "purple",
                callback: function() {
                  $(that.addFormSelector).validForm(function(onSuccess) {
                    var action = $(that.addFormSelector).find(".form_action").val();
                    var id = $(that.addFormSelector).find(".form_item_id").val();

                    if((action ?? "add") == "add") {
                      that.createItem($(that.addFormSelector).serialize(), function(success){
                        processPopupServerResponse(popup, success);
                        onSuccess(success);
                      });
                    } else {
                      that.updateItem(id, $(that.addFormSelector).serialize(), function(success){
                        processPopupServerResponse(popup, success);
                        onSuccess(success);
                      });
                    }
                  });
                  return false;
                }
              },
              cancel: {
                label: L("CANCEL"),
                className: "btn",
                callback: () => {
                  that.$emit("onCancel")
                }
              }
            }
          });

          $(".modal-supplier_invoice").css("opacity", 0.05);
          $("#part_purchase_date").on("focusout", function(e) {
            $(".modal-supplier_invoice").css("opacity", 0.05);
          })
          /*$(".close").on("click", function(){
            
          })*/
          popup.on("hide.bs.modal", function(e) {
            $(".modal-supplier_invoice").css("opacity", 1);
          })

          //console.log($("#part_purchase_date"))
          
          
        }, "html", function(jqXHR, textStatus, thrownErr) {
          App.unblockUI();
          processXHRError(jqXHR, textStatus, thrownErr);
          console.log( "Request add customer failed: " + textStatus );
        })
      },
      createItem: function(data, callback, shouldApplyResult = true){
        let that = this;
        if(callback == undefined) callback = function(success){ };
        var message_text = "<h1>"+L("SAVING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
        App.blockUI({ message: message_text ,boxed: true, zIndex: 20000 });

        return new Promise((resolve, reject) => {
          $.ajax({
            url: that.addFormBaseEndPoint+"/save",
            type: "POST",
            data: { form : data, from: "select2" },
            dataType: "json",
            success: function(result) {
              App.unblockUI();
              if (shouldApplyResult) {
                that.applyItemResult(result);
              }
              callback(true);
              resolve(result);
            },
            error: function(jqXHR, textStatus, thrownErr) {
              App.unblockUI();
              processXHRError(jqXHR, textStatus, thrownErr);
              callback(false);
              console.log( "Request addItem failed: " + textStatus );
              reject(thrownErr || textStatus);
            }
          });
        });
      },
      editItem: function(){
        let that = this;        
        let id;
        if (!that.value.itemId || that.value.itemId == '') { that.value.itemId = that.value.id;}
        if (that.value.itemId) {
          id = that.value.itemId.toString().split("-");
          if (id.length > 1){
            id = id[1];
          } else { 
            id = id[0];
          }
        }
        
        var message_text = "<h1>"+L("PROCESSING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
        App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });

        let from = "select2";
        if (that.$parent !== null && that.$parent.$parent !== null &&
            that.$parent.$parent.$options.name == "supplier-invoice-item-list")
            {
              from = "select2supplier";
            }
        $.post(that.editFormBaseEndPoint, { id : id, from: from }, function(msg){
          App.unblockUI();

          var popup = bootbox.dialog({ 
            message: msg,
            title: that.editFormTitle,
            className: "modal-item",
            size: "medium",
            buttons: {
              save: {
                label: L("SAVE"),
                className: "purple",
                callback: function() {
                  $(that.editFormSelector).validForm(function(onSuccess){
                    that.updateItem(id, $(that.editFormSelector).serialize(), function(success){
                      processPopupServerResponse(popup, success);
                      onSuccess(success);
                    });
                  });
                  return false;
                }
              },
              cancel: {
                label: L("CANCEL"),
                className: "btn",
                callback: function() {

                }
              }
            }
          });

          $(".modal-supplier_invoice").css("opacity", 0.05);
          popup.on("hide.bs.modal", function(e) {
            $(".modal-supplier_invoice").css("opacity", 1);
          })

        }, "html", function(jqXHR, textStatus, thrownErr) {
          App.unblockUI();
          processXHRError(jqXHR, textStatus, thrownErr);
          console.log( "Request edit item failed: " + textStatus );
        })
      },
      updateItem: function(id, data, callback, shouldApplyResult = true){
        let that = this;
        console.log(callback);
        if(callback == undefined) callback = function(success){ };
        var message_text = "<h1>"+L("SAVING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
        App.blockUI({ message: message_text ,boxed: true, zIndex: 20000 });

        return new Promise((resolve, reject) => {
          $.ajax({
            url: that.editFormBaseEndPoint+"/save",
            type: "POST",
            data: { id: id, form : data, from: "select2" },
            dataType: "json",
            success: function(result) {
              App.unblockUI();
              if (shouldApplyResult) {
                that.applyItemResult(result);
              }
              callback(true);
              resolve(result);
            },
            error: function(jqXHR, textStatus, thrownErr) {
              App.unblockUI();
              processXHRError(jqXHR, textStatus, thrownErr);
              callback(false);
              console.log( "Request editItem failed: " + textStatus );
              reject(thrownErr || textStatus);
            }
          });
        });
      },
      quickAddItem: function() {
        const baseEndpoint = this.addFormBaseEndPoint.replace(/part\/add\/?$/, '');
        const defaultSupplierId = $('.modal-supplier_invoice #supplier_invoice_supplier_id').length > 0
          ? $('.modal-supplier_invoice #supplier_invoice_supplier_id').val()
          : '';

        openRapidPartModal({
          title: "Création rapide d'une pièce",
          baseEndpoint,
          defaultSupplierId,
          createItem: (data) => this.createItem(data, undefined, false),
          updateItem: (id, data) => this.updateItem(id, data, undefined, false),
          onSelected: (result) => this.applyItemResult(result),
        });
      }
    }
}
</script>
<style lang="scss">
  li.select2-results__option td {
    white-space:nowrap; 
    overflow: hidden;
    text-overflow:ellipsis;
  }  
  li.select2-results__option td.part-number {
    width: 100px;
    max-width: 100px;
  }
  li.select2-results__option td.part-supplier {
    width: 120px;
    max-width: 120px;
    text-align: right;
  }
  li.select2-results__option td.part-name {
    width: 133px;
    max-width: 133px;
  }
  li.select2-results__option td.part-qty {
    width: 50px;
    max-width: 50px;
    text-align: right;
  }
  li.select2-results__option col {
    width: 10%;
  }
</style>
